module.exports = __webpack_public_path__ + "static/banner-img-desktop-opt1-b5bb97a6eab441801ea7915012c361ce.jpg";